import { IMcSearchConfig } from "./SourcingToolArgs";

export enum Frequency {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
  NEVER = "NEVER",
  WEEKLY = "WEEKLY",
}

export interface SavedSearch {
  created_at?: string;
  definition?: IMcSearchConfig;
  id: string;
  name: string;
  frequency?: Frequency;
  updated_at?: string;
  editable?: boolean;
  searchable?: boolean;
}
